import axiosCall from './interceptor';
import URL from '../helper';

export const fetchPlanUsageDetails = async () => {
    const url = `${URL.BASE_URL}fetchAccountUsage `;
    const response = await axiosCall('get', url);
    return response.data;
  };